import styled from '@mui/system/styled';

export const Main = styled('div')({
  paddingInline: 32,
});
